const LinearLoader = ({ show }: { show: boolean }) => {
    return (
        <>
            <div
                className="linear-activity"
                style={{ display: show ? "unset" : "none" }}
            >
                <div className="indeterminate"></div>
            </div>
        </>
    );
};

export default LinearLoader;
